// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__mkqRi","buttons":"PendingPaymentAlert_buttons__2HVtA"};